/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum SalesJourney {
    FlightOnly = 'FlightOnly',
    Package = 'Package'
}

export function SalesJourneyFromJSON(json: any): SalesJourney {
    return SalesJourneyFromJSONTyped(json, false);
}

export function SalesJourneyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SalesJourney {
    return json as SalesJourney;
}

export function SalesJourneyToJSON(value?: SalesJourney | null): any {
    return value as any;
}

